import React from 'react';
import { trustSection } from '../images';
import './TrustSection.css';

function TrustSection() {
    return (
        <section className="trust-section">
            <div className="trust-badges">
                <div className="trust-badge">
                    <span className="trust-icon">2</span>
                    <span>Безплатна доставка до 2 работни дни</span>
                </div>
                <div className="trust-badge">
                    <span className="trust-icon">14</span>
                    <span>14 дни право на връщане</span>
                </div>
                <div className="trust-badge">
                    <span className="trust-icon">3K+</span>
                    <span>3,000+ доволни клиенти</span>
                </div>
                <div className="trust-badge">
                    <span className="trust-icon">4.7</span>
                    <span>Оценка 4.7/5 (131 отзива)</span>
                </div>
            </div>
            <div className="trust-gallery">
                {trustSection.map((img, i) => (
                    <div key={i} className="trust-gallery-item">
                        <img src={img} alt={`Trust visual ${i + 1}`} loading="lazy" />
                    </div>
                ))}
            </div>
        </section>
    );
}

export default TrustSection;
